// Investor API
export type InvestorDetail = {
  investorId: string;
  title: string;
  entityType: string;
  firstName: string;
  middleName: string;
  surname: string;
  entityName: string;
  customerId: string;
  status: string;
}

export function investorDetailTransformer(data: any): InvestorDetail {
  return {
    investorId: data.id,
    title: data.title,
    entityType: data.entityType,
    firstName: data.firstName,
    middleName: data.middleName,
    surname: data.surname,
    entityName: data.entityName,
    customerId: data.customerId,
    status: data.status
  };
}

export type EntityType = {
  id: string;
  type: string;
  group: boolean;
  description: string;
}

export function entityTypeTransformer(data: any): EntityType {
  return {
    id: data.id,
    type: data.form.type,
    group: data.group,
    description: data.description
  };
}
